import { useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

// Store
import { Dispatch, RootState } from '../../../store/store';
import ReportsImages from './reportsImages';
import MainPdfImage from './mainPdfImage';
import { useTranslation } from 'react-i18next';
import { ReportType } from '../../../types/report-type-enum';

export interface ReportItem {
  cycleId: string;
  image: string;
  position: number;
  id: string;
  type: ReportType;
  cycle: {
    name: string;
  };
  is_included: boolean;
  pdfUploadId: string | null;
}

interface IPdfImagesProps {
  cycleReportId?: string;
  reports: ReportItem[];
  loading: boolean;
  mainScreenshot: string;
  getReports: (cycleId: string) => Promise<void>;
  uploadAndSplitPdf: (params: { file: File; cycleId: string }) => Promise<void>;
  updateReportPositions: (reports: ReportItem[]) => Promise<void>;
  updateReportInclude: (params: { reportId: string; isIncluded: boolean }) => Promise<void>;
  deleteReport?: (params: { cycleId: string, reportId: string }) => Promise<void>;
}

const PdfImages:FC<IPdfImagesProps> = ({
  loading,
  reports,
  mainScreenshot,
  getReports,
  uploadAndSplitPdf,
  updateReportPositions,
  updateReportInclude,
  deleteReport,
}) => {
  const { id: cycleId } = useParams<{ id: string }>();
  const { t } = useTranslation();

  useEffect(() => {
    getReports(cycleId);
  }, [cycleId]);

  const zoomedReports = reports?.filter((report) => report.type === ReportType.CHART ) || []
  const uploadedReports = reports?.filter((report) => report.type === ReportType.PDF_PAGE ) || []

  const zommedReporTitle = t('labels.screenshotsFor')
  const uploadedReporTitle = t('labels.uploadedScreenshots')

  return (
    <div className="flex flex-col gap-3">
      <MainPdfImage loading={loading} mainScreenshot={mainScreenshot} />
      <ReportsImages
        title={zommedReporTitle}
        loading={loading}
        reports={zoomedReports}
        updateReportPositions={updateReportPositions}
        updateReportInclude={updateReportInclude}
        deleteReport={deleteReport}
      />

      <ReportsImages
        title={uploadedReporTitle}
        loading={loading}
        reports={uploadedReports}
        updateReportPositions={updateReportPositions}
        updateReportInclude={updateReportInclude}
        uploadAndSplitPdf={uploadAndSplitPdf}
        deleteReport={deleteReport}
        onDataChanged={() => getReports(cycleId)}
      />
    </div>
  );
};

const mapState = (state: RootState) => ({
  reports: state.reports.reports,
  mainScreenshot: state.reports.mainScreenshot,
  loading: state.reports.loading,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getReports: dispatch.reports.fetchReports,
  uploadAndSplitPdf: dispatch.reports.uploadAndSplitPdf,
  takeGraphScreenshot: dispatch.reports.takeGraphScreenshot,
  updateReportPositions: dispatch.reports.updateReportPositions,
  updateReportInclude: dispatch.reports.updateReportInclude,
  deleteReport: dispatch.reports.deleteReport,
});

export default connect(mapState, mapDispatch)(PdfImages);
